import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'reactstrap';
import {
  FormGroup,
  Field,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup
} from '@availity/form';
import { Navigate } from 'react-router-dom';
import * as yup from 'yup';
import PropTypes from 'prop-types';
import housingstore from '../stores/housingstore';
import ProgressValidatedForm from '../../Common/components/ProgressValidatedForm';
import withNavigate from '../../Common/components/withNavigate';

@observer
class TransportationInformation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      redirectToPersonalHousingHist: false,
      redirectToSignatures: false,
      redirectToAHAHRap: false,
      redirectToLandingPage: false,
    }

    if(window.performance) {
			if(performance.navigation.type == 1) {
        housingstore.resetSupportiveHousingPage();
				window.location.href = '#';
			}
		}
  }

  componentWillMount() {
    if (housingstore.getSupportiveHousingRouteStatus('/personalhousinghist') !== 'completed') {
      housingstore.resetSupportiveHousingPage();
      housingstore.resetSupportiveHousingRoutesStatus();
      this.setState({ redirectToLandingPage: true });
    } else if (
      housingstore.getSupportiveHousingRouteStatus('/transportationinformation') !== 'completed' &&
      housingstore.getSupportiveHousingRouteStatus('/transportationinformation') !== 'active'
    ) {
      housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
      housingstore.setSupportiveHousingRouteStatus('/transportationinformation', 'active');
    }
  }

  componentDidMount() {

    window.onpopstate = () => {
      this.props.navigate(1);
    }
  }

  setpublicTrasportationRadio = value => {
    housingstore.setPublicTransportRadio(value);
  }

  setvehicleRadio = value => {
    housingstore.setVehicleRadio(value);
  }

  setTransportationDescription = event => {
    const { value } = event.target;
    housingstore.updateTransportationDescription(value);
  }

  setIndividualHousingRadio = value => {
    housingstore.setIndividualHousingRadio(value);
  }

  setindividualHousingOptions = event => {
    const { value } = event.target;
    housingstore.updateIndividualHousingOptions(value);
  }

  getRentalAssistance = value => {
    housingstore.setRentalAssistanceCat(value);
  }

  getOtherRentalAssistanceDetails = event => {
    const { value } = event.target;
    housingstore.setOtherRentalAssistanceDetails(value);
  }

  getRentalSubsidy = value => {
    housingstore.setRentalSubsidyCategories(value);
  }

  getOtherRentalSubsidyDetails = event => {
    const { value } = event.target;
    housingstore.setOtherRentalSubsidyDetails(value);
  }

  getContinuumOfCare = value => {
    housingstore.setContinuumOfCareCat(value);
  }

  getOtherContinuumOfCareDetails = event => {
    const { value } = event.target;
    housingstore.setOtherContinuumOfCareDetails(value);
  }

  setDeptOfCommerceSubsidized = event => {
    const { value } = event.target;
    housingstore.updateDeptOfCommerceSubsidized(value);
  }

  setOtherHUDOrUSDASubsidy = event => {
    const { value } = event.target;
    housingstore.updateOtherHUDOrUSDASubsidy(value);
  }

  setCountyOrCityProgramField = event => {
    const { value } = event.target;
    housingstore.updateCountyOrCityProgramField(value);
  }

  setOtherProgramsField = event => {
    const { value } = event.target;
    housingstore.updateOtherProgramsField(value);
  }

  goBack = () => {
    housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
    housingstore.setSupportiveHousingRouteStatus('/personalhousinghist', 'active');
    housingstore.setSupportiveHousingRouteStatus('/transportationinformation', 'inactive');
    this.setState({ redirectToPersonalHousingHist: true });
  }

  submit = pendingRoute => {
    const { memberInfo } = housingstore;
    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;
    const defaultRoute = isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? '/ahah-rap' : '/signature';
    const nextRoute = pendingRoute || defaultRoute;
    
    housingstore.setSupportiveHousingPageStatus('#housingassessment', 'active');
    housingstore.setSupportiveHousingRouteStatus('/transportationinformation', 'completed');
    
    if (nextRoute === '/ahah-rap') {
      this.setState({ redirectToAHAHRap: true });
      return;
    }

    if (nextRoute === '/signature') {
      this.setState({ redirectToSignatures: true });
      return;
    }

    this.props.navigate(nextRoute);
  }

  render() {

    const { redirectToPersonalHousingHist, redirectToSignatures, redirectToAHAHRap, redirectToLandingPage } = this.state;

    const {
      publicTrasportationRadio,
      vehicleRadio,
      transportationDescription,
      individualHousingRadio,
      rentalAssistanceCat,
      rentalSubsidyCategories,
      otherRentalAssistanceDetails,
      otherRentalSubsidyDetails,
      continuumOfCareCat,
      otherContinuumOfCareDetails,
      deptOfCommerceSubsidized,
      otherHUDOrUSDASubsidy,
      countyOrCityProgram,
      otherProgramsDetails,
      supportiveHousingPagesAHAH,
      supportiveHousingPagesNoAHAH,
      memberInfo 
    } = housingstore;

    const { isHomeless, isEnrolleeEligibleForAHAH } = memberInfo;

    const supportiveHousingPages = (isHomeless === 'Yes' && isEnrolleeEligibleForAHAH === 'Yes' ? supportiveHousingPagesAHAH : supportiveHousingPagesNoAHAH);

    if (redirectToPersonalHousingHist) {
      return <Navigate to="/personalhousinghist" />
    }

    if (redirectToSignatures) {
      return <Navigate to="/signature" />
    }

    if (redirectToAHAHRap) {
      return <Navigate to="/ahah-rap" />
    }

    if (redirectToLandingPage) {
      return <Navigate to="/" />
    }

    return (
      <>
        <div className="border-form">
          <div className='spacer-50' />

          <ProgressValidatedForm
            pages={supportiveHousingPages}
            enableReinitialize
            initialValues={{
              publicTrasportationRadio: publicTrasportationRadio,
              vehicleRadio: vehicleRadio,
              transportationDescription: transportationDescription,
              individualHousingRadio: individualHousingRadio,
              rentalAssistanceCheckBox: rentalAssistanceCat.map(x => x),
              rentalAssistanceDetails: otherRentalAssistanceDetails,
              rentalSubsidyCheckBox: rentalSubsidyCategories.map(x => x),
              rentalSubsidyDetails: otherRentalSubsidyDetails,
              continuumOfCareCheckBox: continuumOfCareCat.map(x => x),
              continuumOfCareDetails: otherContinuumOfCareDetails,
              deptOfCommerceSubsidizedField: deptOfCommerceSubsidized
            }}
            onSubmit={this.submit}
          >
            <small className="required-fields">*required fields</small>
            <div className="spacer" />
            <h2 className="poppinsH2">
              Housing Assessment
            </h2>
            <em>
              <small className="label-font">
                Please fill out to the best of your ability. Information in this section assesses the
                individual’s housing preferences, needs and assets. This information does not impact
                eligibility. Identify individual traits that support the client’s ability to obtain and
                maintain housing.
              </small>
            </em>
            <div className="spacer" />
            <div className="d-flex">
              <h5 className="poppinsH5">
                Transportation Information
              </h5>
            </div>
            <div className="titleSpacer" />
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client rely on public transportation?
              </p>
              <RadioGroup inline value={publicTrasportationRadio} name="publicTrasportationRadio" onChange={this.setpublicTrasportationRadio}>
                <Radio className="label-font-round" name="publicTrasportationOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="publicTrasportationOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <div className="d-flex">
              <p className="label-font mr-5">
                Does the client have a vehicle?
              </p>
              <RadioGroup inline value={vehicleRadio} name="vehicleRadio" onChange={this.setvehicleRadio}>
                <Radio className="label-font-round" name="vehicleOption" customInput label="Yes" value="Yes" />
                <Radio className="label-font-round" name="vehicleOption" customInput label="No" value="No" />
              </RadioGroup>
            </div>
            <Row>
              <Col sm="6">
                <Field
                  type="textarea"
                  id="transportationDescription"
                  label={
                    <h6 className="label-font">
                      Please describe the client's transportation needs:
                    </h6>
                  }
                  name="transportationDescription"
                  className={'textAreaHeightDetails straighten-borders form-control'}
                  onChange={this.setTransportationDescription}
                  value={transportationDescription}
                  row="3"
                  cols="200"
                  maxLength={250}
                />
                <p className="small text-right mb-0 label-font">250 Character max</p>
              </Col>
            </Row>
            <hr className="mtb-32" />
            <h2 className="poppinsH5">
              Housing options to review/explore
            </h2>
            <div className="titleSpacer" />
            <div className="d-flex">
              <p className="label-font mr-5">
                Are any of the options below available and appropriate for the individual?
              </p>
              <RadioGroup inline value={individualHousingRadio} name="individualHousingRadio" onChange={this.setIndividualHousingRadio}>
                <Radio className="label-font-round" name="individualHousingOption" label="Yes" value="Yes" />
                <Radio className="label-font-round" name="individualHousingOption" label="No" value="No" />
              </RadioGroup>
            </div>
            <em className="label-font mr-5">
              If yes, select all that apply:
            </em>
            <div className="titleSpacer" />
            <h5 className="poppinsH5">
              Tenant-based rental assistance
            </h5>
            <div className="titleSpacer" />
            <Row>
              <Col className="tenantBasedCol" sm="4">
                <CheckboxGroup value={rentalAssistanceCat} name="rentalAssistanceCheckBox" onChange={this.getRentalAssistance}>
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Housing choice"
                    name="housingChoice"
                    value="Housing choice"
                    disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Non-elderly disabled"
                    name="nonElderlyDisabled"
                    value="Non-elderly disabled"
                    disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Veteran’s Assistance Supportive Housing"
                    name="veteranAssistanceSupportiveHousing"
                    value="Veteran’s Assistance Supportive Housing"
                    disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                  />
                </CheckboxGroup>
              </Col>
              <Col sm="4">
                <CheckboxGroup name="rentalAssistanceCheckBox" value={rentalAssistanceCat} className="custom-AvCheckboxGroup" onChange={this.getRentalAssistance}>
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Family Unification Program"
                    name="familyUnificationProgram"
                    value="Family Unification Program"
                    disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Housing Opportunities for Persons With AIDS (HOPWA)"
                    name="hOPWA"
                    value="Housing Opportunities for Persons With AIDS (HOPWA)"
                    disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                  />
                  <Checkbox
                    customInput
                    className="label-font no-display"
                    label="Other:"
                    name="otherRentalAssistance"
                    value="Other"
                    disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                  />
                </CheckboxGroup>
                {
                  rentalAssistanceCat.indexOf('Other') >= 0 ?
                    <FormGroup className="noMargin-buttom" for="rentalAssistanceDetails">
                      <Field
                        type="textarea"
                        id="rentalAssistanceDetails"
                        name="rentalAssistanceDetails"
                        className={'straighten-borders form-control form-group custom-OtherTextArea'}
                        onChange={this.getOtherRentalAssistanceDetails}
                        value={otherRentalAssistanceDetails}
                        row="3"
                        col="200"
                        maxLength={250}
                        disabled={individualHousingRadio.length === 0 || individualHousingRadio === "No"}
                      />
                      <p className="small text-right mb-0 label-font character-limit">250 Character max</p>
                    </FormGroup>
                    :
                    null
                }
              </Col>
            </Row>
            <hr className="mtb-32" />
            <div className="titleSpacer" />
            <h5 className="poppinsH5">
              Project-based rental subsidy
            </h5>
            <div className="titleSpacer" />
            <Row>
              <Col className="projectBasedCol" sm="4">
                <CheckboxGroup value={rentalSubsidyCategories} name="rentalSubsidyCheckBox" onChange={this.getRentalSubsidy}>
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="HUD 811 (supportive housing for persons with disabilities)"
                    name="opt1"
                    value="HUD 811 (supportive housing for persons with disabilities)"
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="HUD 202 (supportive housing for the elderly)"
                    name="opt2"
                    value="HUD 202 (supportive housing for the elderly)"
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Low-Income Housing Tax Credit"
                    name="opt3"
                    value="Low-Income Housing Tax Credit"
                  />
                </CheckboxGroup>
              </Col>
              <Col sm="4">
                <CheckboxGroup value={rentalSubsidyCategories} name="rentalSubsidyCheckBox" className="custom-AvCheckboxGroup" onChange={this.getRentalSubsidy}>
                  <Checkbox
                    customInput
                    className="label-font no-display"
                    label="Other:"
                    name="opt4"
                    value="Other"
                  />
                </CheckboxGroup>
                {
                  rentalSubsidyCategories.indexOf('Other') >= 0 ?
                    <FormGroup className="noMargin-buttom" for="rentalSubsidyDetails">
                      <Field
                        type="textarea"
                        id="rentalSubsidyDetails"
                        name="rentalSubsidyDetails"
                        className={'straighten-borders form-control form-group custom-OtherTextArea'}
                        onChange={this.getOtherRentalSubsidyDetails}
                        value={otherRentalSubsidyDetails}
                        row="3"
                        col="200"
                        maxLength={250}
                      />
                      <p className="small text-right mb-0 label-font character-limit">250 Character max</p>
                    </FormGroup>
                    :
                    null
                }
              </Col>
            </Row>
            <hr className="mtb-32" />
            <div className="titleSpacer" />
            <h5 className="poppinsH5">
              Continuum of care
            </h5>
            <div className="titleSpacer" />
            <Row>
              <Col className="continuumCol" sm="4">
                <CheckboxGroup value={continuumOfCareCat} name="continuumOfCareCheckBox" onChange={this.getContinuumOfCare}>
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Shelter care"
                    name="shelterCare"
                    value="Shelter care"
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Homelessness Prevention and Rapid Re-Housing Program (HPRP)"
                    name="hPRP"
                    value="Homelessness Prevention and Rapid Re-Housing Program (HPRP)"
                  />
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Permanent supportive housing"
                    name="permanentSupportiveHousing"
                    value="Permanent supportive housing"
                  />
                </CheckboxGroup>
              </Col>
              <Col className="continuumColEnd" sm="4">
                <CheckboxGroup value={continuumOfCareCat} name="continuumOfCareCheckBox" className="custom-AvCheckboxGroup" onChange={this.getContinuumOfCare}>
                  <Checkbox
                    customInput
                    className="label-font mb-5 no-display"
                    label="Transitional housing"
                    name="transitionalHousing"
                    value="Transitional housing"
                  />
                  <Checkbox
                    customInput
                    className="label-font no-display"
                    label="Other:"
                    name="otherContinuumOfCare"
                    value="Other"
                  />
                </CheckboxGroup>
                {
                  continuumOfCareCat.indexOf('Other') >= 0 ?
                    <FormGroup className="noMargin-buttom" for="continuumOfCareDetails">
                      <Field
                        type="textarea"
                        id="continuumOfCareDetails"
                        name="continuumOfCareDetails"
                        className={'straighten-borders form-control form-group custom-OtherTextArea'}
                        onChange={this.getOtherContinuumOfCareDetails}
                        value={otherContinuumOfCareDetails}
                        row="3"
                        col="200"
                        maxLength={250}
                      />
                      <p className="small mb-0 label-font rightAlignCharMax">250 Character max</p>
                    </FormGroup>
                    :
                    null
                }
              </Col>
            </Row>
            <Row>
              <Col sm="8">
                <FormGroup className="label-font" for="deptOfCommerceSubsidizedField">
                  <Field
                    type="text"
                    id="deptOfCommerceSubsidizedField"
                    name="deptOfCommerceSubsidizedField"
                    label="Department of Commerce subsidized:"
                    className='straighten-borders custom-textField'
                    onChange={this.setDeptOfCommerceSubsidized}
                    value={deptOfCommerceSubsidized}
                    maxLength={250}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="titleSpacer" />
            <Row>
              <Col sm="8">
                <FormGroup className="label-font" for="otherHUDOrUSDASubsidyField">
                  <Field
                    type="text"
                    id="otherHUDOrUSDASubsidyField"
                    name="otherHUDOrUSDASubsidyField"
                    label="Other HUD or USDA subsidy:"
                    className='straighten-borders custom-textField'
                    onChange={this.setOtherHUDOrUSDASubsidy}
                    value={otherHUDOrUSDASubsidy}
                    maxLength={250}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="titleSpacer" />
            <Row>
              <Col sm="8">
                <FormGroup className="label-font" for="countyOrCityProgramField">
                  <Field
                    type="text"
                    id="countyOrCityProgramField"
                    name="countyOrCityProgramField"
                    label="County/city program:"
                    className='straighten-borders custom-textField'
                    onChange={this.setCountyOrCityProgramField}
                    value={countyOrCityProgram}
                    maxLength={250}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="titleSpacer" />
            <Row>
              <Col sm="8">
                <FormGroup className="label-font" for="otherPrograms">
                  <Field
                    type="text"
                    id="otherPrograms"
                    name="otherPrograms"
                    label="Other:"
                    className='straighten-borders custom-textField'
                    onChange={this.setOtherProgramsField}
                    value={otherProgramsDetails}
                    maxLength={250}
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="spacer-64" />
            <Button type="button" color={"primary"} className={'btn btn-primary buttonBack'} onClick={this.goBack}>
              Back
            </Button>
            <Button type="submit" color={"primary"} className={'btn btn-primary nextBtn'}>
              Next
            </Button>
          </ProgressValidatedForm>
        </div>
        <div className="pb-spacerRem-4" />
      </>
    );
  }
}

export default withNavigate(TransportationInformation);

TransportationInformation.propTypes = {
  navigate: PropTypes.func
};